import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {SystemConfigurationProxy} from "./system.configuration.proxy";
import {ISystemConfiguration} from "../interfaces/interfaces";

/**
 ****************************************************************
 * Service class for getting system configuration from server before the login
 *
 ****************************************************************
 */
@Injectable({ providedIn: 'root' })
  export class SystemConfigurationPreLoginService {

	constructor(private systemConfigurationProxy:SystemConfigurationProxy) {}

	public getPreLoginSystemConfiguration(): Observable<ISystemConfiguration> {
		return this.systemConfigurationProxy.GetPreLoginSystemConfiguration();
	}
}
